import type { Feat } from '../types';
import featsData from '../../public/feats.json';
export const feats: Feat[] = featsData as Feat[];
